import React, { useCallback, useEffect, useRef, useState } from "react";
import LoaderScreen from "./LoaderScreen";
// import VideoLanguagePage from "./VideoLanguagePage";
// import VideoSettingPage from "./VideoSettingPage";
import forwardIcon from "../assets/forwardAudio.png";
import backwardIcon from "../assets/backwardAudio.png";
// import AudioSettings from "./AudioSettings";
import { fetchContent } from "../services/api";
import pauseIcon from "../assets/pause.png";
import playIcon from "../assets/play.png";
import liveIcon from "../assets/LiveIcon.png";
import settingIcon from "../assets/settingIcon.png";
// import languageIcon from "../assets/languageIcon.png";
import speedIcon from "../assets/Speed.png";
import VideoSettingPage from "./videoPlayer/VideoSettingPage";
import AudioSettingsPage from "./AudioSettingsPage";
import AudioBitratePage from "./AudioBitratePage";
import DetailsScreen from "./DetailsScreen";
import shaka from "shaka-player/dist/shaka-player.ui.js";
import Wrapper from "./shared/Wrapper";
import backIcon from "../assets/back-button.png";
import { createDrmLicense, getVideoUrl } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { getBaseURL } from "./networkManager/networkHandler";
import { useContext } from "react";
import { AppContext } from "../AppContext";
import { Translate } from "./LanguageChanger";
import { handleMotamoPlayPauseEvent, sendAudioWatchListEvent, mediaPlaybackMotamoEvent } from "../Analytics/MatomoManager/audioMatomoMedia";
import { logAudioErrorEvent } from "../Analytics/MatomoManager/errorLog";

let defaultSelected = "";
let videoElement = null;
let vdoElement = null;
let intervalId = null;
let firstPlay = true;

const AudioPlayer = ({
  videoSrc,
  type, // 'mp4', 'hls', 'mpd', 'drm'
  availableBitrates,
  adConfig = null, // { client: true/false, adTimes: [time1, time2, ...], vastXmlUrl: 'url_to_vast_xml' }
  backgroundImage,
  controlsColor = "#FFFFFF",
  controlBarHeight = "50px",
  progressBarColor = "#FF671F",
  itemData,
  onAdStart,
  onAdEnd,
  onPlay,
  onPause,
  onResume,
  onForward,
  onRewind,
  onError,
  onBack,
  isLive = false,
  apiEndpoint,
  DRMToken = null,
  mpdXMLInfo,
  DrmInformatin,
  GetVideoUrlData,
  // loading,
  trackData,
  isNext,
  setIsNext,
  isPrev,
  setIsPrev,
  itemDetails,
  isLogedIn,
}) => {
  const videoRef = useRef(null);
  const adVideoRef = useRef(null);
  const isMounted = useRef(true);
  const initCancelled = useRef(false);
  const currentTimeRef = useRef(0);
  const mediaIdRef = useRef(null);
  const playPauseButtonRef = useRef(false);
  const backwardButtonRef = useRef(false);
  const forwardButtonRef = useRef(false);
  const videoSettingRef = useRef(false);
  const lastPlayedTrackIdRef = useRef(null);
  const playerRef = useRef(null);
  const LanguageRef = useRef(false);
  // const [itemData, setItemData] = useState(itemDataFromParent);
  const [focusedButton, setFocusedButton] = useState("playPause");
  const [currentBitrate, setCurrentBitrate] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isAdPlaying, setIsAdPlaying] = useState(false);
  const [controlsVisible, setControlsVisible] = useState(false);
  const [lastUserActivity, setLastUserActivity] = useState(Date.now());
  const [showBgImage, setShowBgImage] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [showSpeedControl, setShowSpeedControl] = useState(false);
  const [isAudio, setType] = useState(false);
  const [shouldloadVideo, shouldLoad] = useState(true);
  const [playerBitrates, setPlayerBitrates] = useState([]);
  const [activeTrack, setActiveTrack] = useState(null);
  // const [loading, setState] = useState(true);
  const [incurrentTime, setinCurrentTime] = useState("00:00:00");
  const [totalTime, setTotalTime] = useState("00:00:00");
  const [is_live, setIs_live] = useState(false);
  const [selectSpeed, setSelectSpeed] = useState(1);
  const [loading, showLoader] = useState(true);
  const [NextData, setNextData] = useState(null);
  const [VideoDetails, setVideoDetails] = useState(itemData);
  const [BackgroundImage, setBackgroundImage] = useState(backgroundImage);
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [adAudio, setadAudio] = useState(false);
  const [duration_ad, setduration_ad] = useState(0);
  const [player, setPlayer] = useState(null);
  const [ISTrack, setISTrack] = useState(false);
  const [ISTrackPre, setISTrackPre] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentDrmInfo, setCurrentDrmInfo] = useState(DrmInformatin?.data);
  const [bitrate, setBitrate] = useState();
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const [isSeekBarFocused, setIsSeekBarFocused] = useState(false);

  console.log("DrmInformatin", DrmInformatin, currentDrmInfo);
  console.log("GetVideoUrlData", GetVideoUrlData);

  console.log("trackData 108",trackData)
  const [state, setState] = useState({
    error: false,
    shouldFocusToKeyBoard: true,
    shouldFocusGrid: false,
    shouldCloseMenu: true,
    shouldShowModal: false,
    isBackButtonSelected: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
  });
  const {
    error,
    shouldFocusToKeyBoard,
    shouldFocusGrid,
    shouldCloseMenu,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    isBackButtonSelected,
  } = state;

  let drmDataToPlay = DrmInformatin;
  // let VideoDetails = itemData
  // let BackgroundImage = backgroundImage

  const userId = localStorage.getItem("profileId");
  const getCountry = localStorage.getItem("country");
  let headers = {
    iskid: "0",
    Langid: "1",
    "Content-Type": "application/json",
    country: getCountry,
    age: "12",
  };
  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
  };

  function formatSecondsToHMS(seconds) {
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  }

  //  useEffect(() => {
  //   isMounted.current = true;
  //   return () => {
  //     isMounted.current = false;
  //     if (videoRef.current) {
  //       videoRef.current.pause();
  //       videoRef.current.removeAttribute("src");
  //       videoRef.current.load();
  //     }
  //     if (player) {
  //       player.destroy(); 
  //     }
  //   };
  // }, []);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.removeAttribute("src");
        videoRef.current.load();
      }
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, []);

  const detailToDetail = (recommendationItem) => {
    // setData(recommendationItem);
    // setScreen("DetailsScreen")
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    navigateToScreen("", recommendationItem);
    setTimeout(function () {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
      navigateToScreen("DetailsScreen", recommendationItem);
    }, 100);
  };
  console.log("VideoDetails", VideoDetails);

  useEffect(() => {
    initCancelled.current = false;
    if (currentDrmInfo) {
      initVideo(currentDrmInfo);
    } else {
      if (GetVideoUrlData !== null) {
        initVideo(GetVideoUrlData[0]);
      } else {
        initVideo(VideoDetails);
      }
    }
    return () => {
      initCancelled.current = true;
      if (player) {
        player.destroy(); // Cleanup on unmount
      }
    };
  }, [currentDrmInfo]);

  useEffect(() => {
    if (screen !== "") {
      initCancelled.current = true;
      if (videoRef.current) {
        videoRef.current.pause();
      }
    }
  }, [screen]);

  // useEffect(() => {
  //   if (currentDrmInfo) {
  //     initVideo(currentDrmInfo);
  //   } else {
  //     if(drmDataToPlay?.data){
  //       initVideo(GetVideoUrlData[0])
  //     }else{
  //       initVideo(drmDataToPlay?.data)
  //     }
  //   }
  //   return () => {
  //     if (player) {
  //       player.destroy(); // Cleanup on unmount
  //     }
  //   };
  // }, [currentDrmInfo]);

  // useEffect(() => {
  //   if(drmDataToPlay?.data){
  //     initVideo(GetVideoUrlData[0])
  //   }else{
  //     initVideo(drmDataToPlay?.data)
  //   }
  //   return () => {
  //     if (player) {
  //       player.destroy(); // Cleanup on unmount
  //     }
  //   };
  // }, []);

 function generateUUID() {
  return crypto.randomUUID();
}

  const sendInitMotamoEvent = async () => {
    const mediaId = `${generateUUID()}${trackData?.[currentIndex]?.id ?? itemData?.id}`;
    mediaIdRef.current = mediaId;
    const audioType = itemDetails?.[0]?.category_title;

      if(sourceContext === "Watchlist"){
     await sendAudioWatchListEvent({
        actionType: "Play",
        itemData,
        itemDetails,
      });
    }


    console.log(parseInt(currentTime), duration, trackData[currentIndex], itemData, "checkingTimeDuration");
   

    // if type is Audio
    if(audioType === "Audio"){
      handleMotamoPlayPauseEvent({eventActionName:"Play",videoRef,itemDetails,itemData,trackData,currentIndex,sourceContext}); 
    }

    // if type is Radio Channels
    else if(audioType === "Radio Channels"){
       sendTestMatomoEvent({
          eventCategory: "LiveRadio",
          eventAction: "Listen",
          eventName: `${itemData?.id}/${itemData?.title}`,
          sourceContext: sourceContext || "",
        });
      handleMotamoPlayPauseEvent({eventActionName:"Play",videoRef,itemDetails,itemData,trackData,currentIndex,sourceContext}); 
    }

  };




  const mediaPlayBackMotamoEvent = async () => {
    // Delegate to shared audio Matomo helper
    return mediaPlaybackMotamoEvent({
      videoRef,
      itemDetails,
      itemData,
      trackData,
      currentIndex,
      DrmInformatin,
      GetVideoUrlData,
      mediaIdRef,
    });
  };






  const initVideo = async (videoData) => {
    console.log("videoData 222", videoData, itemData);
    if (!isMounted.current) return; 

    if (!videoData) {
      onBack && onBack();
    }
    const videoElement = videoRef.current;
    if (!videoElement) return;
    try {
      if (player) {
        await player.destroy();
        if (!isMounted.current) return; 
        setPlayer(null);
      }
      const mediaSource = new MediaSource();
      videoElement.src = URL.createObjectURL(mediaSource);

      videoElement.pause();
      videoElement.src = ""; // Clear previous source
      videoElement.removeAttribute("src");
      videoElement.load(); // Force reload to reset MediaSource

      await new Promise((resolve) => {
        mediaSource.addEventListener(
          "sourceopen",
          () => {
            resolve();
          },
          { once: true }
        );

        // Timeout fallback
        setTimeout(resolve, 2000);
      });
      if (!isMounted.current) return; 
      try {
        if (videoElement.srcObject instanceof MediaSource) {
          if (videoElement.srcObject.readyState !== "open") {
            console.warn("MediaSource not open, recreating...");
            videoElement.src = "";
            await new Promise((resolve) => setTimeout(resolve, 300));
          }
        }
        const newPlayer = new shaka.Player(videoElement);
        const ui = new shaka.ui.Overlay(newPlayer, videoElement, videoElement);
        const controls = ui.getControls();
        const container = controls.getServerSideAdContainer();
        const netEngine = newPlayer.getNetworkingEngine();
        const adManager = newPlayer.getAdManager();
        adManager.initMediaTailor(container, netEngine, videoElement);
        setPlayer(newPlayer);
        playerRef.current = newPlayer; 

        // DRM License URL
        const URL = `${getBaseURL()}/V1/onRequestCreateVideoLicense`;

        newPlayer.configure({
          drm: {
            servers: {
              "com.widevine.alpha": URL,
            },
            advanced: {
              "com.microsoft.playready": {
                distinctiveIdentifierRequired: false,
                persistentStateRequired: false,
                videoRobustness: "SW_SECURE_DECODE",
              },
            },
          },
        });

        // DRM Token Authentication
        newPlayer
          .getNetworkingEngine()
          .registerRequestFilter((type, request) => {
            if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
              request.headers["pallycon-customdata-v2"] = videoData.token;
            }
          });

        var params = {
          adsParams: {},
        };

        if (videoData && videoData?.player_params) {
          const playerParams = videoData?.player_params;
          if (playerParams.includes("os")) {
            params.adsParams.os = "4";
          }
          if (playerParams.includes("ai")) {
            params.adsParams.ai = "wavespb.com";
          }
          if (playerParams.includes("trq")) {
            params.adsParams.trq = `${Date.now().toString()}`;
          }
          if (playerParams.includes("dt")) {
            params.adsParams.dt = "4";
          }
          if (playerParams.includes("ag")) {
            params.adsParams.ag = "25";
          }
          if (playerParams.includes("gn")) {
            params.adsParams.gn = "male";
          }
          if (playerParams.includes("vmi")) {
            params.adsParams.vmi = "web";
          }
          if (playerParams.includes("ifa")) {
            params.adsParams.ifa = "";
          }
          if (playerParams.includes("cvl")) {
            params.adsParams.cvl = `${GetVideoUrlData[0]?.video_duration}`;
          }
          if (playerParams.includes("ctid")) {
            params.adsParams.ctid = `${itemData?.id}`;
          }
          if (playerParams.includes("ctype")) {
            params.adsParams.ctype = "VOD";
          }
          if (playerParams.includes("gnr")) {
            params.adsParams.gnr = `${itemData?.genres}`;
          }
          if (playerParams.includes("prerollasi")) {
            params.adsParams.prerollasi = "web";
          }
          if (playerParams.includes("collection")) {
            params.adsParams.collection = `${itemData?.collection_id}`;
          }

          let uri = null;
          let videoUrl = videoData?.file_url;
          console.log(videoUrl, videoData, "VideoUrl....");
          try {
            uri = await adManager.requestMediaTailorStream(videoUrl, params);
          } catch (error) {
            console.log("error 275", error);
           const currentTime = videoRef.current?.currentTime || 0;
            logAudioErrorEvent(currentTime,itemDetails, itemData, trackData,currentIndex, error);
            uri = videoData?.file_url;
          }
          await newPlayer
            .load(uri)
            .then(() => { })
            .catch((error) => {
              console.error("Error loading video:", error);
            const currentTime = videoRef.current?.currentTime || 0;
            logAudioErrorEvent(currentTime,itemDetails, itemData, trackData,currentIndex, error);
            });

          adManager.addEventListener(shaka.ads.Utils.AD_STARTED, (e) => {
            setadAudio(true);
            setduration_ad(e.ad.getDuration());
          });

          adManager.addEventListener(shaka.ads.Utils.AD_STOPPED, (e) => {
            setadAudio(false);
          });
        } else {
          console.log("videoData.file_url", videoData.file_url);
          await newPlayer
            .load(videoData.file_url)
            .then(() => { })
         .catch((error) => {
              if (error.code == 4000) {
                onBack && onBack();
              }
              console.error("Error loading video:", error);
            const currentTime = videoRef.current?.currentTime || 0;
            logAudioErrorEvent(currentTime,itemDetails, itemData, trackData,currentIndex, error);
            });
        }

        showLoader(false);
        // sending event on play
        sendInitMotamoEvent();

        // if (initCancelled.current) return;
        videoElement
          .play()
          .catch((error) => {
             const currentTime = videoRef.current?.currentTime || 0;
            logAudioErrorEvent(currentTime,itemDetails, itemData, trackData,currentIndex, error);
          });

        const btrate = newPlayer.getVariantTracks();
        setPlayerBitrates(btrate);
      }  catch (error) {
        console.error("Error loading video:", error);
        const currentTime = videoRef.current?.currentTime || 0;
        logAudioErrorEvent(currentTime,itemDetails, itemData, trackData,currentIndex, error);

      }
    } catch (error) {
      videoElement.load(); // Force reload to reset MediaSource
      const currentTime = videoRef.current?.currentTime || 0;
      logAudioErrorEvent(currentTime,itemDetails, itemData, trackData,currentIndex, error);
    }
    sendInitMotamoEvent();
  };

  const handleNextAudio = async () => {
    if (currentIndex + 1 >= trackData.length) {
      setISTrack(true);
      return;
    }
    // Send Stop event BEFORE clearing the video to capture correct currentTime
    handleMotamoPlayPauseEvent({eventActionName:"Stop",videoRef,itemDetails,itemData,trackData,currentIndex,sourceContext});
    
    showLoader(true);
    if (player) {
      await player.destroy();
      setPlayer(null);
    }
   
    
    setTimeout(async () => {
      const videoElement = videoRef.current;
      videoElement.pause();
      videoElement.src = ""; // Clear previous source
      videoElement.removeAttribute("src");

      setISTrack(false);
      setISTrackPre(false);

      const nextIndex = currentIndex + 1;
      setCurrentIndex(nextIndex);

      const nextVideoId = trackData[nextIndex].id;
      const nextTrackTitle = trackData[nextIndex].title;
      try {
        // const videoUrlResponse = await fetchContent(
        //   `/V1/getVideoUrl/${nextVideoId}/userId/${userId}?display=false`,
        //   "GET",
        //   headers
        // );

        const videoUrlResponse = await getVideoUrl(nextVideoId, userId);
        console.log(videoUrlResponse, "Checking Response");

        if (videoUrlResponse.data) {
          setVideoDetails(videoUrlResponse.data);
          const postBody = {
            vdc_id: videoUrlResponse.data.vdc_id,
            media_id: videoUrlResponse.data.id,
            loading: false,
          };

          // const drmDetails = await fetchContent(
          //   "/V1/createDrmLicense",
          //   "POST",
          //   headers,
          //   JSON.stringify(postBody)
          // );

          const drmDetails = await createDrmLicense(postBody);
          if (drmDetails?.data) {
            setCurrentDrmInfo(drmDetails.data);
            initVideo(drmDetails.data); // Load new video with correct token
            // Send next track event
            sendTestMatomoEvent({
              eventCategory: "Audio",
              eventAction: "Next",
              eventName: `${nextVideoId}/${itemData?.title}/${nextTrackTitle}(AOD)`,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching DRM details:", error);
      }
    }, 500);
  };



  const handlePreviousAudio = async () => {
    if (currentIndex - 1 < 0) {
      console.log("No previous tracks available.");
      setISTrackPre(true);
      return;
    }
    setTimeout(async () => {
      showLoader(true);
      if (player) {
        await player.destroy();
        setPlayer(null);
      }
      const videoElement = videoRef.current;
      videoElement.pause();
      videoElement.src = ""; // Clear previous source
      videoElement.removeAttribute("src");
      const previousIndex = currentIndex - 1;
      const previousTrackTitle = trackData[previousIndex].title;
      setISTrack(false);
      await loadTrack(currentIndex - 1);

      

      sendTestMatomoEvent({
        eventCategory:"Audio",
        eventAction: "Previous",
        eventName: `${trackData[previousIndex]?.id}/${itemData?.title}/${previousTrackTitle}(AOD)`,
      });
    }, 500);
  };

  const loadTrack = async (newIndex) => {
    setCurrentIndex(newIndex);
    const videoId = trackData[newIndex].id;
    try {
      // const videoUrlResponse = await fetchContent(
      //   `/V1/getVideoUrl/${videoId}/userId/${userId}?display=false`,
      //   "GET",
      //   headers
      // );

      const videoUrlResponse = await getVideoUrl(videoId, userId);

      console.log(videoUrlResponse, "Checking Response");

      if (videoUrlResponse.data) {
        setVideoDetails(videoUrlResponse.data);

        const postBody = {
          vdc_id: videoUrlResponse.data.vdc_id,
          media_id: videoUrlResponse.data.id,
        };

        // const drmDetails = await fetchContent(
        //   "/V1/createDrmLicense",
        //   "POST",
        //   headers,
        //   JSON.stringify(postBody)
        // );

        const drmDetails = await createDrmLicense(postBody);

        if (drmDetails?.data) {
          console.log("New DRM details:", drmDetails);
          setCurrentDrmInfo(drmDetails.data);
          initVideo(drmDetails?.data); // Load new video with correct token
        }
      }
    } catch (error) {
      console.error("Error fetching DRM details:", error);
    }
  };
  console.log("GetVideoUrlData", GetVideoUrlData);
  useEffect(() => {
    if (GetVideoUrlData !== null && GetVideoUrlData[0]?.is_live === 1) {
      setIs_live(true);
    }
  }, [GetVideoUrlData]);

  // const handleNextAudio = async () => {
  //   console.log("calling")
  //   const videoId = trackData[2].id

  //   // navigateToScreen("DetailsScreen",videoId)
  //   const videoUrlResponse = await fetchContent(
  //     `/V1/getVideoUrl/${videoId}/userId/${userId}?display=false`,
  //     "GET",
  //     headers
  //   );
  //   console.log("videoUrlResponse", videoUrlResponse)
  //   if (videoUrlResponse.data) {
  //     setBackgroundImage(videoUrlResponse.data.poster_url)
  //     // VideoDetails = videoUrlResponse.data
  //     setVideoDetails(videoUrlResponse.data)
  //     const postBody = {
  //       vdc_id: videoUrlResponse.data.vdc_id,
  //       media_id: videoUrlResponse.data.id,
  //     };
  //     const drmDetails = await Promise.all([
  //       fetchContent(
  //         "/V1/createDrmLicense",
  //         "POST",
  //         headers,
  //         JSON.stringify(postBody)
  //       ),
  //     ]);
  //     if (drmDetails) {
  //       drmDataToPlay = drmDetails[0]
  //       setNextData(drmDetails[0].data)

  //     }
  //     console.log("drmDetails", drmDetails)
  //   }
  // }

  const handleTimeUpdate = () => {
    console.log("handleTimeUpdate...");
    if (!videoRef.current) return;
    const current = videoRef.current.currentTime;
    currentTimeRef.current = current;
    setinCurrentTime(formatTime(current));
    // setCurrentTime(current);

    if (
      adConfig &&
      adConfig.client &&
      adConfig.adTimes.includes(Math.floor(current)) &&
      !isAdPlaying
    ) {
      fetchVastAd(adConfig.vastXmlUrl);
      console.log("add implementation....", adConfig.vastXmlUrl, adConfig);
    }
  };

  console.log("drmDataToPlay.....", drmDataToPlay);

  const handleLoadedMetadata = () => {
    console.log("handleLoadedMetadata...");
    if (!videoRef.current) return;
    setDuration(videoRef.current.duration);
  };

  // const handleEnded = () => {
  //   if (isAdPlaying) {
  //     setIsAdPlaying(false);
  //     adVideoRef.current.style.display = "none";
  //     videoRef.current.style.display = "block";
  //     videoRef.current.currentTime = currentTimeRef.current;
  //     videoRef.current.play();
  //     onAdEnd && onAdEnd();
  //   } else {
  //     setIsPlaying(false);
  //     // onBack && onBack();
  //   }
  // };

  const handleEnded = () => {
    if (trackData.length > 1) {
      handleNextAudio();
    } else {
      onBack && onBack();
    }
  };

  function checkPlaybackState() {
    const playbackRate = player.getPlaybackRate();

    if (playbackRate > 0) {
      // console.log("Player is playing");
      // Perform actions for playing state
    } else {
      //console.log("Player is paused");
      // Perform actions for paused state
    }
  }

  // const handlePlayPause = () => {
  //   if (!vdoElement) {
  //     return;
  //   }
  //   if (isPlaying) {
  //     //vdoElement.addEventListener('pause', onPause);
  //     vdoElement && vdoElement.pause();
  //     setIsPlaying(false);
  //     onPause && onPause();
  //   } else {
  //     // vdoElement.addEventListener('playing', onPlay);
  //     vdoElement && vdoElement.play();
  //     setIsPlaying(true);
  //     onPlay && onPlay();
  //   }
  // };



  const handlePlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(false);
        handleMotamoPlayPauseEvent({eventActionName:"Resume",videoRef,itemDetails,itemData,trackData,currentIndex,sourceContext});
      } else {
        videoRef.current.pause();
        setIsPlaying(true);
        handleMotamoPlayPauseEvent({eventActionName:"Pause",videoRef,itemDetails,itemData,trackData,currentIndex,sourceContext});
      }
    }
  };

  const fetchVastAd = (vastXmlUrl) => {
    console.log("vastXmlUrl...", vastXmlUrl);
    fetch(vastXmlUrl)
      .then((response) => response.text())
      .then((vastXml) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(vastXml, "text/xml");
        console.log("xmlDoc.....", xmlDoc);
        const mediaFileUrl =
          xmlDoc.getElementsByTagName("MediaFile")[0].textContent || "";
        playAd(mediaFileUrl);
      })
      .catch((error) => console.error(""));
  };

  const playAd = (adUrl) => {
    console.log("playAd...", adUrl);
    setIsAdPlaying(true);
    videoRef.current.pause();
    adVideoRef.current.src = adUrl;
    adVideoRef.current.currentTime = 0;
    adVideoRef.current.style.display = "block";
    videoRef.current.style.display = "none";
    adVideoRef.current.play().catch((error) => console.error());
    onAdStart && onAdStart();
  };

  const handleBitrateChange = (bitrate) => {
    const selectedTrack = playerBitrates[bitrate];
    if (!selectedTrack) return;
    player.selectVariantTrack(bitrate, true);
    setBitrate(bitrate);
    console.log(bitrate, "setBitrate");
    const qualityKbps = `${Math.round(selectedTrack.bandwidth / 1000)}`;

    console.log(qualityKbps, playerBitrates, "setBitrate");

    sendMatomoPopupEvent({ type: "Quality", value: `${qualityKbps}kbps` });

  };
  const handleOpenBitrate = () => {
  setShowSettings(true);
  setShowSpeedControl(false);   // Close speed control
};

const handleOpenSpeed = () => {
  setShowSpeedControl(true);
  setShowSettings(false);       // Close quality settings
};


  const handleRewind = () => {
    // setIsPrev(true)
    vdoElement.currentTime = vdoElement.currentTime - 10;
    onRewind && onRewind();
  };

  const handleForward = () => {
    // setIsNext(true)
    vdoElement.currentTime = vdoElement.currentTime + 10;
    onForward && onForward();
  };

  // const handleSeek = (event) => {
  //   const seekTime =
  //     (event.nativeEvent.offsetX / event.target.clientWidth) * duration;
  //   vdoElement.currentTime = seekTime;
  // };

  const handleSeek = (event) => {
  const seekTime =
    (event.nativeEvent.offsetX / event.target.clientWidth) * duration;
  if (videoRef.current) {
    videoRef.current.currentTime = seekTime;
    setCurrentTime(seekTime); // Force immediate UI update
    setinCurrentTime(formatTime(seekTime)); // Update time display too
  }
};

  // const handleBack = () => {
  //   console.log("back...key...", showSettings, showSpeedControl);

  //   // videoRef.current.addEventListener("pause", () => {
  //   // setIsPlaying(false);
  //   // setIconType('play');
  //   // setShowIcon(true);
  //   // setTimeout(() => setShowIcon(false), 1000); // Show icon for 1 second
  //   // });
  //   if (!showSettings && !showSpeedControl) {
  //     if (vdoElement !== undefined && vdoElement !== null) {
  //       vdoElement.destroy();
  //       console.log("vdoElement....");
  //       vdoElement.pause();
  //       vdoElement.src = "";

  //       videoElement = null;
  //     }

  //     videoElement = null;
  //     onPause && onPause();
  //     onBack && onBack();
  //     onBack && onBack();
  //     // loadData();
  //     // AddToContinueWatching();
  //     handleMotamoPlayPauseEvent({eventActionName:"Stop",videoRef,itemDetails,itemData,trackData,currentIndex,sourceContext});

  //   }else {
  //     vdoElement.destroy();
  //     vdoElement.pause();
  //     vdoElement.src = "";
  //     videoElement = null;
  //     onPause && onPause();
  //     onBack && onBack();
  //     onBack && onBack();
  //     handleMotamoPlayPauseEvent({eventActionName:"Stop",videoRef,itemDetails,itemData,trackData,currentIndex,sourceContext});

  //   }
  // };

  const handleBack = async () => {
    console.log("back...key...", showSettings, showSpeedControl);
    
    handleMotamoPlayPauseEvent({
      eventActionName: "Stop",
      videoRef,
      itemDetails,
      itemData,
      trackData,
      currentIndex,
      sourceContext
    });

    if (videoRef.current) {
      videoRef.current.pause();
    }
    if (player) {
      try {
        await player.destroy();
        setPlayer(null);
      } catch (e) {
        console.error("Error destroying player:", e);
      }
    }
    if (videoRef.current) {
      videoRef.current.removeAttribute("src");
      videoRef.current.load();
    }
    videoElement = null;
    vdoElement = null;
    onPause && onPause();
    onBack && onBack();

  };

  const handleError = (e) => {
    onError && onError(e);
  };
  useEffect(() => {
    const videoElement1 = videoRef.current;

    if (videoElement1) {
      const updateTime = () => {
        setCurrentTime(videoElement1.currentTime); // Update current time
        setDuration(videoElement1.duration); // Update duration
      };

      videoElement1.addEventListener("timeupdate", updateTime);

      return () => {
        videoElement1.removeEventListener("timeupdate", updateTime);
      };
    }
  }, [VideoDetails]);

  const handleMetadataLoaded = () => {
    if (GetVideoUrlData[0].is_live === 1) {
      setIs_live(true);
    } else {
      if (videoRef.current) {
        console.log(
          "Video is ready. Current Time:",
          videoRef.current.currentTime
        );
        console.log("initialization....");

        // Get the video duration and format it
        const duration = videoRef.current.duration;
        const formattedDuration = formatTime(duration);

        // Update the totalTime state with the formatted duration
        setTotalTime(formattedDuration);
      }
    }
  };

  const formatTime = (time) => {
    if (GetVideoUrlData !== null)
      if (GetVideoUrlData[0]?.is_live !== 1) {
        if (isNaN(time) || time < 0) {
          return "00:00:00"; // Default format when time is not available
        }
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = Math.floor(time % 60);

        return `${hours < 10 ? "0" : ""}${hours}:${minutes < 10 ? "0" : ""
          }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      }
  };

  const handleSettingsClick = () => {
    window.removeEventListener("keydown", handleKeyDownAudio);
    setControlsVisible(true);
    setShowSettings(true); 
    setShowSpeedControl(false);
    // Switch to the settings page when the button is clicked
    // videoRef.current.pause();
    // setIsPlaying(false);
     handleOpenBitrate();
  };

  const handleLanguageClick = () => {
    window.removeEventListener("keydown", handleKeyDownAudio);
    setControlsVisible(true);
    setShowSpeedControl(true);
    setShowSettings(false);
    // videoRef.current.pause();
    // setIsPlaying(false); 
  };

const handleKeyDownAudio = (e) => {
    console.log("Key Pressed:", e.keyCode, "isBackButtonSelected:", isBackButtonSelected, "isSeekBarFocused:", isSeekBarFocused);

    if (showSettings || showSpeedControl) {
      if (e.keyCode === 8 || e.keyCode === 10009 || e.keyCode === 461|| e.keyCode === 13) {
        setShowSettings(false);
        setShowSpeedControl(false);
        setControlsVisible(true);
      }
      return;
    }

    // if (isSeekBarFocused) {
    //     switch (e.keyCode) {
    //         case 37: // Left arrow
    //             if (videoRef.current) videoRef.current.currentTime -= 10;
    //             onRewind && onRewind();
    //             break;
    //         case 39: // Right arrow
    //             if (videoRef.current) videoRef.current.currentTime += 10;
    //             onForward && onForward();
    //             break;
    //         case 40: // Down arrow
    //             setIsSeekBarFocused(false);
    //             setState((prevState) => ({ ...prevState, isBackButtonSelected: false }));
    //             setFocusedButton("playPause");
    //             break;
    //         case 13: // Enter
    //              if (isBackButtonSelected) handleBack();
    //              else handlePlayPause();
    //              break;
    //         case 38: // Up arrow
    //              setState((prevState) => ({ ...prevState, isBackButtonSelected: true }));
    //              setIsSeekBarFocused(false);
    //              setFocusedButton(null);
    //              break;
    //         default:
    //             break;
    //     }
    //     return;
    // }

    const buttons = [ "speedControl", "backward", "playPause", "forward", "bitrateControl" ];

    switch (e.keyCode) {
      case 38: // Up arrow
        const controlButtons = [ "playPause", "backward", "forward", "speedControl", "bitrateControl" ];
        if (isSeekBarFocused){
          setIsSeekBarFocused(false);
          setState((prevState) => ({ ...prevState, isBackButtonSelected: true }));
          setFocusedButton(false);
        }
        else {
        if (controlButtons.includes(focusedButton) && !is_live ) {
          setIsSeekBarFocused(true);
          setFocusedButton(null);
        } else {
          setState((prevState) => ({ ...prevState, isBackButtonSelected: true }));
          setFocusedButton(false);
        }
      }
        break;

      case 40: // Down arrow
        if (isBackButtonSelected && !is_live) {
          setState((prevState) => ({ ...prevState, isBackButtonSelected: false }));
          setIsSeekBarFocused(true);
          setFocusedButton(null);
        }
        else if (isSeekBarFocused ) {
          setIsSeekBarFocused(false);
          setFocusedButton("playPause");
        }
         else if (isBackButtonSelected && is_live) {
          setState((prevState) => ({ ...prevState, isBackButtonSelected: false }));
          setFocusedButton("playPause");
        }
        break;

    case 37: // Left arrow
    if (is_live) {
        const allowedButtons = ["playPause", "bitrateControl"];
        const currentIndex = allowedButtons.indexOf(focusedButton);
        if (currentIndex > 0) setFocusedButton(allowedButtons[currentIndex - 1]);
    } else {
        if (isSeekBarFocused) {
            if (videoRef.current) {
                const newTime = Math.max(0, videoRef.current.currentTime - 10);
                videoRef.current.currentTime = newTime;
                setCurrentTime(newTime);
                setinCurrentTime(formatTime(newTime));
            }
            onRewind && onRewind();
        }
        else {
          const currentIndex = buttons.indexOf(focusedButton);
          if (focusedButton === "bitrateControl") {
              setFocusedButton("forward");
          } else if (currentIndex > 0) {
              setFocusedButton(buttons[currentIndex - 1]);
          }
        }
    }
    break;

case 39: // Right arrow
    if (is_live) {
        const allowedButtons = ["playPause", "bitrateControl"];
        const currentIndex = allowedButtons.indexOf(focusedButton);
        if (currentIndex < allowedButtons.length - 1) setFocusedButton(allowedButtons[currentIndex + 1]);
    } else {
      if (isSeekBarFocused) {
          if (videoRef.current) {
              const newTime = Math.min(duration, videoRef.current.currentTime + 10);
              videoRef.current.currentTime = newTime;
              setCurrentTime(newTime);
              setinCurrentTime(formatTime(newTime));
          }
          onForward && onForward();   
      }
        else {
        const currentIndex = buttons.indexOf(focusedButton);
        if (focusedButton !== "bitrateControl" && currentIndex !== -1) {
            setFocusedButton(buttons[currentIndex + 1]);
        }
      }
    }
    break;

      case 13: // Enter
        if (isBackButtonSelected) handleBack();
        if (focusedButton === "playPause") handlePlayPause();
        else if (focusedButton === "backward") handlePreviousAudio();
        else if (focusedButton === "forward") handleNextAudio();
        else if (focusedButton === "speedControl") handleLanguageClick();
        else if (focusedButton === "bitrateControl") handleSettingsClick();
        break;

      case 8: case 461: case 10009:
        handleBack();
        break;

      default:
        break;
    }
};
  console.log("GetVideoUrlData", GetVideoUrlData);

  useEffect(() => {
    const interval = setInterval(() => {
      mediaPlayBackMotamoEvent();
    }, 5000);
  
    return () => clearInterval(interval);
  }, [trackData, currentIndex, itemDetails, itemData, GetVideoUrlData, DrmInformatin]);



  useEffect(() => {
    console.log("hello call 1");
    const videoElement = videoRef.current;
    videoElement.addEventListener("play", () => {
      // showLoader(false);
      // setIsPlaying(true);
      setShowBgImage(false);
      setControlsVisible(true);
      onPlay && onPlay();
      // setTimeout(function () {
      //   window.addEventListener("keydown", handleKeyDownAudio);
      // }, 200);
    });
    // const handleKeyDownAudioWrapper = (e) => handleKeyDownAudio(e);
    videoElement.addEventListener("pause", () => onPause && onPause());
    videoElement.addEventListener("timeupdate", handleTimeUpdate);
    videoElement.addEventListener("loadedmetadata", handleLoadedMetadata);
    videoElement.addEventListener("ended", handleEnded);
    videoElement.addEventListener("error", handleError);
    // setTimeout(function(){window.addEventListener("keydown", handleKeyDownAudio);},4000);
    if (!loading) {
      window.addEventListener("keydown", handleKeyDownAudio);
    }

    const controlTimeout = setTimeout(() => {
      // if (Date.now() - lastUserActivity > 10000) {
      clearTimeout(controlTimeout);
      setControlsVisible(false);
    }, 5000);

   





    return () => {
      videoElement.removeEventListener("timeupdate", handleTimeUpdate);
      videoElement.removeEventListener("loadedmetadata", handleLoadedMetadata);
      videoElement.removeEventListener("ended", handleEnded);
      videoElement.removeEventListener("error", handleError);
      window.removeEventListener("keydown", handleKeyDownAudio);
      clearTimeout(controlTimeout);
      // audioMatamoMedia();
    };
  }, [
    GetVideoUrlData,
    videoSrc,
    type,
    adConfig,
    lastUserActivity,
    onAdEnd,
    onAdStart,
    onError,
    onPause,
    onPlay,
    controlsVisible,
    shouldloadVideo,
    isPlaying,
    apiEndpoint,
    focusedButton,
    showBgImage,
    showSettings,
    showSpeedControl,
    videoElement,
    isPrev,
    isNext,
    NextData,
    drmDataToPlay,
    trackData,
    currentIndex,
    itemDetails,
    itemData,
    DrmInformatin,
  ]);

  // useEffect(() => {
  //   try {
  //     if (isPlaying) {
  //       const interval = setInterval(() => {
  //         fetch(`${apiEndpoint}?time=${currentTimeRef.current}`)
  //           .then((response) => response.json())
  //           .then((data) => console.log(""))
  //           .catch((error) => console.error(""));
  //       }, 5000);

  //       return () => clearInterval(interval);
  //     }
  //   } catch (e) {}
  // }, [
  //   videoSrc,
  //   type,
  //   adConfig,
  //   lastUserActivity,
  //   onAdEnd,
  //   onAdStart,
  //   onError,
  //   onPause,
  //   onPlay,
  //   controlsVisible,
  //   shouldloadVideo,
  //   isPlaying,
  //   apiEndpoint,
  //   focusedButton,
  //   showBgImage,
  //   showSettings,
  //   showSpeedControl,
  //   videoElement,
  // ]);

  const handleSpeedControl = (speed) => {
    setSelectSpeed(speed);
    // vdoElement.playbackRate = speed;
    if (videoRef.current) {
      videoRef.current.playbackRate = speed;
    }
    setControlsVisible(true);

    const speedValue = speed || "unknown";
    sendMatomoPopupEvent({ type: "Speed", value: `${speedValue}x` });
  };

const sendMatomoPopupEvent = ({ type, value }) => {
    let eventCategory = type === "Speed" ? "SelectSpeedPopup" : "SelectSettingPopup";
    let eventAction = "Select";
    let eventName = "";

    const audioType = itemDetails?.[0]?.category_title || "Audio";
    const itemId = itemData?.id || "";
    const itemTitle = itemData?.title || "";
    // const currentTitle = itemDetails[0]?.title

    switch (audioType) {
      case "Radio Channels":
        eventName = `LiveRadio/${itemId}/${itemTitle}/${type}(${value})`;
        break;

      case "Audio":
      default:
        eventName = `Audio/${itemId}/${itemTitle}-${itemTitle}/${type}(${value})`;
        break;
    }

    sendTestMatomoEvent({
      eventCategory,
      eventAction,
      eventName,
    });
  };



  // Define the button order

  const styles = {
    container: {
      position: "relative",
      width: "100%",
      height: "100%",
      backgroundColor: "#000037",
      // backgroundColor: "#000",
      backgroundSize: "cover",
      backgroundPosition: "center",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
    },
    video: {
      width: "100%",
      height: "100%",
      display: isAdPlaying ? "none" : "block",
    },
    adVideo: {
      width: "100%",
      height: "100%",
      display: isAdPlaying ? "block" : "none",
    },
    controls: {
      position: "absolute",
      bottom: "80px",

      width: "90%",
      left: "50%",
      transform: "translateX(-50%)",
      height: controlBarHeight,
      display: controlsVisible ? "flex" : "none",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: controlsColor,
      transition: "opacity 0.5s",
      opacity: controlsVisible ? 1 : 0,
      zindex: 1000,
    },
    controlsAudio: {
      position: "absolute",
      bottom: "20%",
      // top:"auto",
      width: "60%",
      left: "50%",

      transform: "translateX(-50%)",
      height: controlBarHeight,
      // display: controlsVisible ? "flex" : "none",
      display: "block",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: controlsColor,
      transition: "opacity 0.5s",
      opacity: 1,
      zindex: 1000,
    },
    name: {
      position: "absolute",
      bottom: "24%",
      color: "#FFF",
    },
    button: {
      padding: "10px",
      fontSize: "16px",
      color: "#FFF",
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      width: "17rem",
    },
    progressBar: {
      flexGrow: 1,
      height: "6px",
      backgroundColor: !isLive ? "#333" : "#FF671F",
      position: "relative",
      cursor: "pointer",
    },
    progress: {
      height: "100%",
      backgroundColor: progressBarColor,
    },
    adMarker: {
      position: "absolute",
      width: "3px",
      height: "100%",
      backgroundColor: !isLive ? "red" : "transparent",
      marginTop: "-10px",
    },
    timeDisplay: {
      padding: "10px",
      color: !isLive ? "#FFF" : "transparent",
    },
    timeDisplayAudio: {
      padding: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      color: !isLive ? "#FFF" : "transparent",
    },
    settingsLanguageContainer: {
      display: controlsVisible ? "flex" : "none",
      justifyContent: "center",
      position: "absolute",
      bottom: "50px",
      width: "100%",
      gap: "7rem",
      bottom: "2rem",
    },
    settingsLanguageItem: {
      margin: "0 20px",
      position: "relative",
      right: is_live ? "11rem" : "0",
    },
    controlButtons: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      display: controlsVisible ? "flex" : "none",
      gap: "20px",
    },
    controlButtonsAudio: {
      position: "absolute",
      bottom: "7%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      // display: controlsVisible ? "flex" : "none",
      gap: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "67%",
      padding: "0 10px",
    },
    controlButton: {
      padding: "10px",
      fontSize: "20px",
      color: "#FFF",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      background: "none",
      margin: "auto",
      position: "relative",
      left: is_live ? "7rem" : "0",
      // outline: focusedButton === "playPause" ? "3px solid #FF671F" : "none",
    },
    backwardButton: {
      padding: "10px",
      fontSize: "20px",
      color: "#FFF",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      background: "none",
      // outline: focusedButton === "backward" ? "3px solid #FF671F" : "none", // Highlight focused button
    },
    forwardButton: {
      padding: "10px",
      fontSize: "20px",
      color: "#FFF",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      background: "none",
      // outline: focusedButton === "forward" ? "3px solid #FF671F" : "none", // Highlight focused button
    },
    settingsWrapper: {
      position: "absolute", // This will place the settings page in the top-right corner
      top: "10px", // Position it from the top of the main page
      right: "10px", // Position it from the right of the main page
      zIndex: 100, // Ensure it appears above other content like the video player
    },
  };

  // useEffect(() => {
  //   const handleKeyDownAudioWrapper = (e) => handleKeyDownAudio(e);

  //   // Add the event listener
  //   window.addEventListener("keydown", handleKeyDownAudioWrapper);

  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDownAudioWrapper);
  //   };
  // }, [showSettings, showSpeedControl]);

  // console.log(itemData)
  if (screen !== "DetailsScreen") {
    return (
      <>
        <div
          style={{
            position: "absolute",
            top: "1.6rem",
            zIndex: 100,
          }}
        >
          <Wrapper
            as="button"
            isAudio={true}
            style={{
              backgroundColor: "transparent",
              border: "none",
              marginLeft: "1rem",
              borderRadius: "1rem",
              aspectRatio: "1/1",
              cursor: "pointer",
              
              outline: isBackButtonSelected? "4px solid #EC008C" : "none",
            }}
            
            onClick={(e) => {
           if (!showSettings && !showSpeedControl) {
              handleBack();
              // handleClick(null, -2);
           }
            }}
          >
            <img src={backIcon} width={50} height={50} />
          </Wrapper>
        </div>
        <div style={styles.container}>
          <img
            src={VideoDetails?.poster_url}
            alt="Background"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 0,
              opacity: 0.4,
              // background: "#0E1653",
            }}
          />
          <video
            ref={videoRef}
            style={styles.video}
            onError={handleError}
            controls={false}
            autoPlay
            preload="auto"
            height="100vh"
            width="100vw"
          // onLoadedMetadata={handleMetadataLoaded}
          />
          <video
            ref={adVideoRef}
            style={styles.adVideo}
            onError={handleError}
            controls={false}
            autoPlay
            preload="auto"
            height="100vh"
            width="100vw"
          // onLoadedMetadata={handleMetadataLoaded}
          />

          <img
            src={VideoDetails?.poster_url}
            alt="Playing"
            style={{
              width: "60%",
              height: "60%",
              position: "absolute",
              top: "7%",
              zIndex: 0,
              opacity: 1,
            }}
          />

          <div style={styles.name}>
            {/* {console.log(itemData, "Videos")} */}
            <h2>{VideoDetails?.title}</h2>
          </div>
          <div style={styles.controlsAudio}>
            {adAudio && (
              <div
                style={{
                  ...styles.controlsAudio,
                  position: "absolute",
                  bottom: "4rem",
                  left: "2rem",
                  width: "auto",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                    backgroundColor: "rgb(0 0 0 / 40%)",
                    padding: "10px 20px",
                    borderRadius: "10px",
                  }}
                // onClick={handleSkipAd}
                >
                  Ad
                </span>
              </div>
            )}
            <div style={styles.progressBar} onClick={handleSeek}>
              {!adAudio && (
                <div
                  style={{
                    ...styles.progress,
                    width: is_live
                      ? `100%`
                      : `${(currentTime / duration) * 100}%`,
                  }}
                ></div>
              )}
              {adAudio && (
                <div
                  style={{
                    ...styles.progress,
                    width:
                      duration_ad && !isNaN(duration_ad)
                        ? `${Math.min((currentTime / duration_ad) * 100, 100)}%`
                        : "0%",
                  }}
                ></div>
              )}
              {!is_live && !adAudio && (
                <div
                  style={{
                    position: 'absolute',
                    left: `${(currentTime / duration) * 100}%`,
                    top: '50%',
                    transform: isSeekBarFocused
                      ? 'translate(-50%, -50%) scale(1.5)'
                      : 'translate(-50%, -50%) scale(1)',
                    width: '15px',
                    height: '15px',
                    backgroundColor: progressBarColor,
                    borderRadius: '50%',
                    transition: 'transform 0.2s ease-in-out',
                    boxShadow: isSeekBarFocused ? '0 0 10px #fff' : 'none',
                  }}
                ></div>
              )}
            </div>

            {!is_live ? (
              <div style={styles.timeDisplayAudio}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>{formatTime(currentTime)}</div>
                  <div>
                    {adAudio ? formatTime(duration_ad) : formatTime(duration)}
                  </div>
                </div>
              </div>
            ) : (
              <img
                src={liveIcon}
                style={{
                  position: "absolute",
                  width: "104px",
                  height: "43px",
                  float: "right",
                  right: "0px",
                  bottom: "4rem",
                  // marginTop: "-7vh",
                  // marginLeft: "84.5vw",
                }}
              />
            )}
          </div>

          <div className="controlBTN" style={styles.controlButtonsAudio}>
            {!adAudio && (
              <div
                style={styles.settingsLanguageItem}
                onKeyDown={handleKeyDownAudio}
              >
                {console.log("isLive....", is_live)}
                {!is_live && (
              //    <button
              //      style={{
              //     ...styles.button,
              //         width: "13rem",
              //        borderRadius: "10px",
              //              outline:
              //        focusedButton === "speedControl"
              //        ? "3px solid #EC008C"
              //        : "none",
              //      }}
              //  ref={LanguageRef}
              //       onClick={handleLanguageClick}
              //    >
              //       <img src={speedIcon} />
              //       <span
              //          style={{
              //       position: "relative",
              //        left: "20px",
              //        bottom: "13px",
              //        }}
              //        > 
              //         {<Translate langKey={"speed"} />} {`(${selectSpeed}x)`}
              //       </span>
              //      </button>
              <Wrapper
              isAudio={true}
                   style={{
                  ...styles.button,
                      width: "13rem",
                     borderRadius: "10px",
                           outline:
                     focusedButton === "speedControl"
                     ? "3px solid #EC008C"
                     : "none",
                   }}
               ref={LanguageRef}
                    onClick={handleLanguageClick}
                 >
                    <img src={speedIcon} />
                    <span
                       style={{
                    position: "relative",
                     left: "20px",
                     bottom: "13px",
                     }}
                     > 
                      {<Translate langKey={"speed"} />} {`(${selectSpeed}x)`}
                    </span>
                   </Wrapper>
                )}
              </div>
            )}

            <>
              {!is_live && trackData?.length > 0 && !adAudio ? (
                <button
                  style={{
                    ...styles.controlButton,
                    outline:
                      focusedButton === "backward"
                        ? "3px solid #EC008C"
                        : "none",
                  }}
                  ref={backwardButtonRef}
                  onClick={handlePreviousAudio}
                >
                  <img
                    src={backwardIcon}
                    style={{
                      width: "60px",
                      height: "60px",
                      filter:
                        ISTrackPre || trackData?.length < 2
                          ? "invert(0.5)"
                          : "none",
                    }}
                  />
                </button>
              ) : (
                ""
              )}
              {!adAudio && (
              <button
                style={{
                  ...styles.controlButton,
                  outline:
                    focusedButton === "playPause"
                      ? "3px solid #EC008C"
                      : "none",
                }}
                ref={playPauseButtonRef}
                onClick={handlePlayPause}
              >
                {console.log("isPlaying", isPlaying)}
                {!isPlaying ? (
                  <img
                    src={pauseIcon}
                    style={{ width: "70px", height: "70px" }}
                  />
                ) : (
                  <img
                    src={playIcon}
                    style={{ width: "70px", height: "70px" }}
                  />
                )}
              </button>)}
            
              {!is_live && trackData?.length > 0 && !adAudio ? (
                <button
                  style={{
                    ...styles.controlButton,
                    outline:
                      focusedButton === "forward"
                        ? "3px solid #EC008C"
                        : "none",
                  }}
                   
                  ref={forwardButtonRef}
                  onClick={() => {
                 handleNextAudio();
                  }}
                >
                  <img
                    src={forwardIcon}
                    style={{
                      width: "60px",
                      height: "60px",
                      filter:
                        ISTrack || trackData?.length < 2
                          ? "invert(0.5)"
                          : "none",
                    }}
                  />
                </button>
              ) : (
                ""
              )}
            </>

            {!adAudio && (
              <div
                style={styles.settingsLanguageItem}
                onKeyDown={handleKeyDownAudio}
              >
               {/* <button
              style={{
                     ...styles.button,
                       width: "13rem",
                   borderRadius: "10px",
                       outline:
                  focusedButton === "bitrateControl"
                     ? "3px solid #EC008C"
                      : "none",
                      }}
                  ref={videoSettingRef}
                  onClick={handleSettingsClick}
                       >
                        <img src={settingIcon} />
                            <span
                            style={{
                             position: "relative",
                                    left: "20px",
                                  bottom: "13px",
                                       }}
                                    >
                                  <Translate langKey={"settings"} />
                                </span>
                            </button> */}
                  <Wrapper
                  isAudio={true}
                       style={{
                     ...styles.button,
                       width: "13rem",
                   borderRadius: "10px",
                       outline:
                  
                  focusedButton === "bitrateControl"
                     ? "3px solid #EC008C"
                      : "none",
                      }}
                  ref={videoSettingRef}
                  onClick={handleSettingsClick}
                       >
                        <img src={settingIcon} />
                            <span
                            style={{
                             position: "relative",
                                    left: "20px",
                                  bottom: "13px",
                                       }}
                                    >
                                  <Translate langKey={"settings"} />
                                </span>
                    </Wrapper>
              </div>
            )}
          </div>

          {showSettings && (
            <div style={styles.settingsWrapper}>
              <AudioBitratePage
                onBitrateChange={handleBitrateChange}
                playerBitrates={playerBitrates}
                activeTrack={activeTrack}
                setShowSettings={setShowSettings}
                currentBitrate={bitrate}
              />
            </div>
          )}

          {showSpeedControl && (
            <div style={styles.settingsWrapper}>
              <AudioSettingsPage
                // availableBitrates={availableBitrates}
                onSpeedChange={handleSpeedControl}
                setShowSpeedControl={setShowSpeedControl}
                currentSpeed={`${selectSpeed}x`}
              // mpdXMLInfo={mpdXMLInfo}
              // handleSpeedControl={}
              // handleQualityControl={handleQualityControl}
              />
            </div>
          )}

          {loading && <LoaderScreen />}
        </div>
      </>
    );
  } else if (screen === "DetailsScreen") {
    return (
      console.log("data...."),
      (
        <DetailsScreen
          handleBack={handleBack}
          data={data}
          isLogedIn={isLogedIn}
          detailToDetail={detailToDetail}
        />
      )
    );
  }
};

export default AudioPlayer;
